import { render } from "./UpgradeApplyManagement.vue?vue&type=template&id=5134f825&scoped=true"
import script from "./UpgradeApplyManagement.vue?vue&type=script&lang=js"
export * from "./UpgradeApplyManagement.vue?vue&type=script&lang=js"

import "./UpgradeApplyManagement.vue?vue&type=style&index=0&id=5134f825&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5134f825"],['__file',"src/views/UpgradeApplyManagement/UpgradeApplyManagement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5134f825"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5134f825', __exports__)) {
    api.reload('5134f825', __exports__)
  }
  
  module.hot.accept("./UpgradeApplyManagement.vue?vue&type=template&id=5134f825&scoped=true", () => {
    api.rerender('5134f825', render)
  })

}


export default __exports__